import { FormattedMessage } from 'react-intl';
import { PaloRailCount, PaloRailSection, PaloSideRail } from '@synergy/components-palo';
import { ReactElement, ReactNode } from 'react';

export interface PaloRecordDockProps {
    /** Quiet count beside the attachments heading. */
    count?: number;
    /** The file list. Omit while the record has no id to keep a file under. */
    attachments?: ReactNode;
    /** Sections under the attachments, for the masks that carry more. */
    sections?: PaloRailSection[];
    /** Word shown sideways while the rail is folded; the attachments by default. */
    collapsedLabel?: ReactNode;
}

/**
 * The right-hand rail of a record, which every mask fills the same way: the
 * attachments on top, no tabs, foldable (agreed 2026-09-03).
 *
 * Each mask used to spell the rail out, which meant nine copies of the same
 * section and eighteen of the same heading — and a heading that was translated
 * in one place and hard-coded in the next. The arrangement belongs in one
 * place; a mask contributes its file list and, where it has one, a section of
 * its own.
 */
export const PaloRecordDock = ({ count, attachments, sections, collapsedLabel }: PaloRecordDockProps): ReactElement => {
    const label = <FormattedMessage id="app.common.attachments" />;

    return (
        <PaloSideRail
            sections={[
                {
                    key: 'attachments',
                    label,
                    action: <PaloRailCount value={count} />,
                    content: attachments,
                },
                ...(sections ?? []),
            ]}
            collapsedLabel={collapsedLabel ?? label}
        />
    );
};
